import type { SVGProps } from 'react';

export type IconName =
  | 'dashboard'
  | 'box'
  | 'receipt'
  | 'layers'
  | 'plus'
  | 'edit'
  | 'trash'
  | 'upload'
  | 'refresh'
  | 'close'
  | 'check'
  | 'search'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'warning'
  | 'external'
  | 'star'
  | 'save'
  | 'logout';

const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

const PATHS: Record<IconName, JSX.Element> = {
  dashboard: <path d="M4 4h7v7H4V4Zm9 0h7v4h-7V4ZM4 13h7v7H4v-7Zm9-1h7v8h-7v-8Z" {...S} />,
  box: <path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Zm0 0L12 12m0 0 8.5-4.5M12 12v9" {...S} />,
  receipt: <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Zm3 5h6M9 12h6" {...S} />,
  layers: <path d="m12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5m-18 4 9 5 9-5" {...S} />,
  plus: <path d="M12 5v14M5 12h14" {...S} />,
  edit: <path d="M4 20h4L18.5 9.5a2 2 0 0 0-2.8-2.8L5 17.2V20Zm10.5-11.5 2.8 2.8" {...S} />,
  trash: <path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-8 0 .8 12a1.5 1.5 0 0 0 1.5 1.4h5.4a1.5 1.5 0 0 0 1.5-1.4L18 7" {...S} />,
  upload: <path d="M12 16V4m0 0 4 4m-4-4-4 4M5 20h14" {...S} />,
  refresh: <path d="M4 12a8 8 0 0 1 13.7-5.7L20 8m0 0V4m0 4h-4m4 4a8 8 0 0 1-13.7 5.7L4 16m0 0v4m0-4h4" {...S} />,
  close: <path d="M6 6l12 12M18 6 6 18" {...S} />,
  check: <path d="m4 12 5 5 11-11" {...S} />,
  search: <path d="M11 4a7 7 0 1 0 4.2 12.6L20 21m-2.8-9A6.2 6.2 0 1 1 11 5.8" {...S} />,
  'chevron-down': <path d="m6 9 6 6 6-6" {...S} />,
  'chevron-left': <path d="m15 6-6 6 6 6" {...S} />,
  'chevron-right': <path d="m9 6 6 6-6 6" {...S} />,
  warning: <path d="M12 3 2 20h20L12 3Zm0 6v5m0 3h.01" {...S} />,
  external: <path d="M14 4h6v6m0-6-9 9M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" {...S} />,
  star: <path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17.9 6.6 20l1-6.1L3.2 9.5l6.1-.9Z" fill="currentColor" />,
  save: <path d="M5 4h11l3 3v13H5V4Zm3 0v5h7V4M8 20v-6h8v6" {...S} />,
  logout: <path d="M14 4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8m2-4 4-4-4-4m4 4H10" {...S} />,
};

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
  title?: string;
}

export function Icon({ name, size = 18, title, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {PATHS[name]}
    </svg>
  );
}
